import * as yup from 'yup';
import { TFunction } from 'react-i18next';

export function rules(t: TFunction) {
  return yup.object().shape({
    email: yup.string().required().email().label(t('auth.registerForm.email')),
    password: yup.string().required().label(t('auth.loginForm.password')),
  });
}
